import { useState } from "react";
import { topics } from "@/mocks/home";

const filters = [
  { key: "all", label: "全部" },
  { key: "high", label: "高热度" },
  { key: "mid", label: "中热度" },
  { key: "low", label: "低热度" },
];

const heatMeta: Record<string, { size: string; color: string; dot: string }> = {
  high: {
    size: "text-base md:text-lg px-5 py-3 font-semibold",
    color: "bg-primary-50 text-primary-700 border-primary-200 hover:bg-primary-100",
    dot: "bg-primary-500",
  },
  mid: {
    size: "text-sm md:text-base px-4 py-2.5 font-medium",
    color: "bg-accent-50 text-accent-800 border-accent-200 hover:bg-accent-100",
    dot: "bg-accent-500",
  },
  low: {
    size: "text-xs md:text-sm px-3.5 py-2 font-medium",
    color: "bg-secondary-50 text-secondary-800 border-secondary-200 hover:bg-secondary-100",
    dot: "bg-secondary-400",
  },
};

export default function TopicWall() {
  const [active, setActive] = useState("all");

  const list = active === "all" ? topics : topics.filter((t) => t.heat === active);

  return (
    <section id="topics" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-site px-4 md:px-8">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.24em] text-primary-600">
              <i className="ri-price-tag-3-line text-sm"></i>
              TOPIC WALL
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              话题墙
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-7 text-foreground-600">
              围绕黑料解析持续聚合的高频话题。点开任意标签，即可看到同一脉络下的事件与关联线索。
            </p>
          </div>

          <div className="flex w-fit items-center gap-1 rounded-full border border-background-200 bg-background-100 px-1 py-1">
            {filters.map((f) => (
              <button
                key={f.key}
                type="button"
                onClick={() => setActive(f.key)}
                className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-xs font-medium transition-colors ${
                  active === f.key
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:text-primary-600"
                }`}
              >
                {f.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-9 flex flex-wrap gap-3">
          {list.map((topic) => {
            const meta = heatMeta[topic.heat];
            return (
              <a
                key={topic.name}
                href="#reports"
                className={`group inline-flex cursor-pointer items-center gap-2.5 rounded-full border transition-colors ${meta.size} ${meta.color}`}
              >
                <span className={`h-1.5 w-1.5 rounded-full ${meta.dot}`}></span>
                {topic.name}
                <span className="rounded-full bg-background-50/70 px-2 py-0.5 text-[11px] font-normal text-foreground-500">
                  {topic.count}
                </span>
              </a>
            );
          })}
        </div>

        <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-2">
            <span className="h-1.5 w-1.5 rounded-full bg-primary-500"></span>高热度话题
          </span>
          <span className="inline-flex items-center gap-2">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>中热度话题
          </span>
          <span className="inline-flex items-center gap-2">
            <span className="h-1.5 w-1.5 rounded-full bg-secondary-400"></span>低热度话题
          </span>
        </div>
      </div>
    </section>
  );
}